export default "__VITE_ASSET__DX1u1T50__";